export default "__VITE_ASSET__lwfXdo7V__"